<template>
  <div class="p-4">
    <div class="p-2 mb-5">
      <p class="mb-2 text-xl font-semibold">[{{ listPage.sugang.kname }} {{ listPage.sugang.sugangName }}] 신청자 리스트</p>
      <p class="mb-2 text-lg">
        수강신청기간 : {{ listPage.sugang.startDate }} ~ {{ listPage.sugang.endDate }} | 진행상태 :
        {{ listPage.sugang.status }}
      </p>
      <p>
        <!-- - 수업변경이 있었을 경우 이름, 이메일, 신청일, 수정일이
                <span class="text-red-500">빨간색</span>으로 표시됩니다. -->
      </p>
    </div>
    <ul class="flex flex-wrap items-center gap-4 mb-5">
      <li>
        <select name="" id="" class="border border-solid rounded border-slate-800" v-model="listPage.searchParams.searchValue">
          <option value="0" selected>선택</option>
          <option value="name">이름</option>
          <option value="email">이메일</option>
          <option value="phone">핸드폰</option>
        </select>
      </li>
      <li>
        <div class="flex items-center gap-4">
          <input type="text" class="border border-solid rounded border-slate-800" v-model="listPage.searchParams.searchKeyword" />
          <div class="flex items-center">
            <p class="p-2 text-white bg-blue-600 border border-solid rounded cursor-pointer" @click="listPage.getRegisterList">
              검색
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div>
      <div class="flex justify-between mb-4">
        <ul class="flex gap-4">
          <li>
            <select
              name=""
              id=""
              class="border border-solid rounded border-slate-800"
              v-model="listPage.searchParams.isNewSugang"
              @change="listPage.getRegisterList"
            >
              <option value="">신청구분 선택</option>
              <option value="Y">신규</option>
              <option value="N">재수강</option>
            </select>
          </li>
          <li>
            <select
              name=""
              id=""
              class="border border-solid rounded border-slate-800"
              v-model="listPage.searchParams.waitStatus"
              @change="listPage.getRegisterList"
            >
              <option value="">상태 선택</option>
              <option value="N">신청</option>
              <option value="Y">대기</option>
            </select>
          </li>
          <li>
            <select
              name=""
              id=""
              class="border border-solid rounded border-slate-800"
              v-model="listPage.searchParams.assign"
              @change="listPage.getRegisterList"
            >
              <option value="">상태 선택</option>
              <option value="Y">배정완료</option>
              <option value="N">배정전</option>
              <option value="C">배정실패</option>
            </select>
          </li>
          <li>
            <select
              name=""
              id=""
              class="border border-solid rounded border-slate-800"
              v-model="listPage.searchParams.isSup"
              @change="listPage.getRegisterList"
            >
              <option value="">상태 선택</option>
              <option value="Y">지원</option>
              <option value="N">일반</option>
            </select>
          </li>
        </ul>
        <ul class="flex gap-4">
          <li>
            <p class="p-2 text-white bg-red-700 border border-solid rounded cursor-pointer" @click="listPage.delContents">삭제</p>
          </li>
          <li>
            <p class="p-2 text-white bg-green-700 border border-solid rounded cursor-pointer" @click="listPage.excelDownload">
              Excel 다운로드
            </p>
          </li>
        </ul>
      </div>
      <BagicTable
        :header="listPage.tableHeader"
        :list="listPage.sugangMemberList"
        :pageSize="listPage.searchParams.pageSize"
        :totalRows="listPage.totalCnt"
        :enableCheckBox="true"
        :checkParamName="listPage.checkParamName"
        @paging-click="listPage.movePage"
        :detailRowName="listPage.detailRowName"
        :detailParamName="listPage.detailParamName"
        @check-click="listPage.checkBoxClick"
      >
      </BagicTable>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "@/plugins/axios.js";
import BagicTable from "@/components/BagicTable.vue";
export default {
  components: {
    BagicTable,
  },
  setup() {
    const route = useRoute();

    const listPage = reactive({
      searchParams: {
        idxLeSugang: "",
        isNewSugang: "",
        pageNum: 1,
        pageSize: 50,
        searchKeyword: "",
        searchValue: "0",
        waitStatus: "",
        assign: "",
        isSup: "",
      },
      tableHeader: {
        rowNum: "No",
        createDate: "신청일",
        isNewSugang: "신청구분",
        sugangSupType: "대상자구분",
        waitStatus: "상태",
        assign: "배정유무",
        memberName: "이름",
        memberEmail: "이메일",
        memberMobile: "핸드폰번호",
        sugangLecType: "스케줄",
        sugangLang: "언어",
        sugangType: "수업유형",
        sugangClassName: "클래스",
        sugangName: "과정",
        sugangLevel: "레벨",
        learnTime: "수업기간/횟수",
        lecDayString: "신청요일",
        sugangHopeTime1: "희망시간1",
        sugangHopeTime2: "희망시간2",
        // classTeacher: "강사",
        status: "결제여부",
        updateDate: "수정/취소일",
        supDocument: "지원서류",
      },
      sugang: {
        endDate: "",
        kname: "",
        startDate: "",
        status: "",
        sugangName: "",
      },
      sugangMemberList: [],

      selectedCheckboxes: [],

      checkParamName: "rowNum",

      totalCnt: 0,

      // 리스트 조회 및 검색
      getRegisterList() {
        listPage.searchParams.idxLeSugang = route.query.idxLeSugang;
        axios
          .get("/admin/registerList", {
            params: listPage.searchParams,
          })
          .then(function (res) {
            if (res.data.success) {
              listPage.totalCnt = res.data.data.totalCnt;
              listPage.sugang = res.data.data.sugang;
              listPage.sugangMemberList = res.data.data.sugangMemberList;
              if (Array.isArray(listPage.sugangMemberList)) {
                listPage.sugangMemberList.forEach(function (item) {
                  item.name = `<u><a href="/enrolmentStep1?idxLeSiteMain=${item.idxLeSiteMain}">${item.name}</a></u>`;
                  item.email = `<u><a href="/enrolmentStep1?idxLeSiteMain=${item.idxLeSiteMain}">${item.email}</a></u>`;
                  if (item.supDocument) {
                    item.supDocument = `<a href="${item.supDocument}" target="_blank">지원서류 보기</a>`;
                  }
                });
              }
            } else {
              // alert(res.data.message);
            }
            // listPage.is_loader = false;
          });
      },

      checkBoxClick(selectedCheckboxes) {
        // 선택된 체크박스 정보를 상태에 저장
        listPage.selectedCheckboxes = selectedCheckboxes;
      },

      /**
       * [2024-12-24] 선택된 항목 중 sugangLecType이 "1:1"이 아닌 경우가 있는지 확인
       * @returns {boolean} 1:1이 아닌 항목이 있으면 true, 모두 1:1이면 false
       */
      hasNonOneToOneLecType() {
        return listPage.selectedCheckboxes.some((checkboxId) => {
          const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
          return selectedItem && selectedItem.sugangLecType !== "1:1";
        });
      },

      async delContents() {
        const idxLeSugang = listPage.searchParams.idxLeSugang;
        const selectedIdxLeSugangPayInfoList = listPage.selectedCheckboxes.map((checkboxId) => {
          const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
          return selectedItem ? selectedItem.idxLeSugangPayInfo : null;
        });

        if (selectedIdxLeSugangPayInfoList.length === 0) {
          alert("선택된 수강신청자 정보가 없습니다.");
          return;
        }

        if (listPage.hasNonOneToOneLecType()) {
          alert("1:1 수업만 삭제할 수 있습니다.");
          return;
        }

        if (!confirm("선택한 항목을 삭제하시겠습니까?")) {
          return;
        }

        try {
          const res = await axios.delete("/admin/registerDelete", {
            data: {
              idxLeSugang: idxLeSugang,
              idxLeSugangPayInfoList: selectedIdxLeSugangPayInfoList,
            },
          });

          if (res.data.success) {
            alert("선택한 항목 삭제 완료");
            listPage.getRegisterList();
          } else {
            alert("삭제 실패");
          }
        } catch (error) {
          console.error("삭제 요청 중 오류 발생:", error);
          alert("삭제 요청 중 오류가 발생했습니다.");
        }
      },

      excelDownload() {
        if (listPage.selectedCheckboxes.length === 0) {
          // alert("선택된 항목이 없습니다.");
          const params = {
            idxLeSugang: listPage.searchParams.idxLeSugang,
            idxLeSugangOnePayInfoList: selectedData,
          };

          axios({
            url: "/admin/registerListExcel",
            method: "GET",
            params: params,
            responseType: "blob",
          })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "lifeClassList.xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch((err) => {
              console.error(err);
              return false;
            });
          return;
        }

        const selectedData = listPage.selectedCheckboxes
          .map((checkboxId) => {
            const selectedItem = listPage.sugangMemberList.find((item) => item[listPage.checkParamName] === checkboxId);
            return selectedItem ? selectedItem.idxLeSugangPayInfo : null;
          })
          .filter((idx) => idx !== null);

        const params = {
          idxLeSugang: listPage.searchParams.idxLeSugang,
          idxLeSugangOnePayInfoList: selectedData.join(),
        };

        axios({
          url: "/admin/registerListExcel",
          method: "GET",
          params: params,
          responseType: "blob",
        })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "lifeClassList.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((err) => {
            console.error(err);
            return false;
          });
      },

      movePage(value) {
        listPage.searchParams.pageNum = value;
        listPage.getRegisterList();
      },
    });

    onMounted(() => {
      listPage.getRegisterList();
    });

    return {
      listPage,
    };
  },
};
</script>
<style></style>
